import { useEffect, useState } from "react";
import "./VariationSelector.css";


export default function VariationSelector({
    selectors = [],
    onVariationChange
}) {


    const visibleSelectors =
        selectors.filter(
            selector =>
                selector.attribute.id !== 9
        );



    const getDefaultVariation = () => {

        for (const selector of selectors) {

            const option =
                selector.options.find(
                    item => item.inStock
                );

            if (option) {

                return option;

            }

        }


        return null;

    };



    const [selectedOptions, setSelectedOptions]
        = useState({});



    /*
        Select first variation when page loads
    */

    useEffect(() => {


        const defaultVariation =
            getDefaultVariation();



        if (defaultVariation) {


            onVariationChange(
                defaultVariation
            );


            setSelectedOptions({

                [defaultVariation.variationId]:
                    defaultVariation

            });


        }


    }, [selectors]);





    function selectOption(
        selector,
        option
    ) {


        setSelectedOptions({

            [selector.attribute.id]:
                option

        });



        onVariationChange(option);


    }





    function isSelected(option) {

        return (
            Object.values(selectedOptions)
                .some(
                    item =>
                        item.variationId ===
                        option.variationId
                )
        );

    }




    return (

        <div className="variation-selector">


            {
                visibleSelectors.map(
                    selector => (


                        <div
                            className="attribute-group"
                            key={
                                selector.attribute.id
                            }
                        >

                            <p className="variation-label">
                                {selector.attribute.name}
                            </p>



                            <div className="options">


                                {
                                    selector.options.map(
                                        option => (


                                            <button

                                                key={
                                                    option.variationId
                                                }


                                                disabled={
                                                    !option.inStock
                                                }


                                                className={
                                                    isSelected(option)
                                                        ?
                                                        "active"
                                                        :
                                                        ""
                                                }


                                                onClick={() =>
                                                    selectOption(
                                                        selector,
                                                        option
                                                    )
                                                }

                                            >

                                                {option.label}

                                            </button>


                                        ))

                                }


                            </div>


                        </div>


                    ))

            }


        </div>

    );

}